import {MessageTypes} from '../../const/dataEnum';
import './ConsolidationKudos.scss';

const ConsolidationKudos = ({message}) => {
  const groupedKudos = message.reduce((acc, kudo) => {
    const category = kudo.messageType.name;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(kudo);
    return acc;
  }, {});

  const getCategoryColor = (category) => {
    switch (category) {
      case MessageTypes.KUDOS.text:
        return '#dcf8c6';
      case MessageTypes.CRITICISM.text:
        return '#f4d35e';
      default:
        return '#f8f7ff';
    }
  };

  return (
    <div className="consolidationKudos-container">
      <p>Feedback :</p>
      {groupedKudos && Object.keys(groupedKudos).length > 0 ? (
        Object.keys(groupedKudos).map((category, index) => (
          <div key={index} className="kudos-category">
            <h5 className="category-heading">{category}</h5>
            <div className="kudos-content-container">
              {groupedKudos[category]?.map((kudo, i) => (
                <div className="kudos-item" key={i} style={{backgroundColor: getCategoryColor(category)}}>
                  <p className="kudos-message">
                    <b>{kudo.sender?.fullName || 'Anonymous'}:</b>
                    {kudo.messageContent || 'No message available'}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className="no-messages">
          <p>No messages for the current period</p>
        </div>
      )}
    </div>
  );
};

export default ConsolidationKudos;
